<template>
    <ion-slides @ionSlidesDidLoad="slidesloaded" v-if="!$root.isMobileOrSmall">
<!--        <ion-slide>-->
<!--            <img :src="`${ $store.getters.webservice_url }/storage/bg.jpg`" alt="Background image"/>-->
<!--        </ion-slide>-->
<!--        <ion-slide>-->
<!--            <img :src="`${ $store.getters.webservice_url }/storage/bg-practivision.png`" alt="Background image"/>-->
<!--        </ion-slide>-->
        <ion-slide>
            <img :src="`${ $store.getters.webservice_url }/storage/bg2.jpg`" alt="Background image"/>
        </ion-slide>
        <ion-slide>
            <img :src="`${ $store.getters.webservice_url }/storage/bg3.jpg`" alt="Background image"/>
        </ion-slide>
        <ion-slide>
            <img :src="`${ $store.getters.webservice_url }/storage/bg4.jpg`" alt="Background image"/>
        </ion-slide>
    </ion-slides>
</template>

<script>
    export default {
        name: "Background",
        methods: {
            slidesloaded(event) {
                event.target.getSwiper().then((swiper) => {
                    // swiper.params.slidesPerView = 1;
                    // swiper.params.loop = true;
                    swiper.params.speed = 2500;
                    swiper.params.autoplay.enabled = true;
                    swiper.params.autoplay.delay = 8000;
                    swiper.params.autoplay.disableOnInteraction = false;
                    swiper.autoplay.start();
                });
            }
        },

    }
</script>

<style scoped lang="scss">
    ion-slides {
        pointer-events: none;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

</style>
